// "use client";

// import React, { useState, useEffect } from "react";
// import Image from "next/image";
// import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
// import {
//   Cormorant_Garamond,
//   Playfair_Display,
//   Inter,
//   Montserrat,
//   Libre_Baskerville,
// } from "next/font/google";
// import HeroBanner from "../HeroBanner";

// const cormorant = Cormorant_Garamond({
//   subsets: ["latin"],
//   weight: ["300", "400", "500", "600", "700"],
// });

// const playfair = Playfair_Display({
//   subsets: ["latin"],
//   weight: ["400", "500", "600", "700", "800", "900"],
// });

// const inter = Inter({
//   subsets: ["latin"],
//   weight: ["300", "400", "500", "600", "700"],
// });

// const montserrat = Montserrat({
//   subsets: ["latin"],
//   weight: ["300", "400", "500", "600", "700", "800"],
// });

// const libre = Libre_Baskerville({
//   subsets: ["latin"],
//   weight: ["400", "700"],
// });

// interface PictureAttributes {
//   url: string;
//   alternativeText: string | null;
//   caption?: string | null;
//   width?: number;
//   height?: number;
// }

// interface Picture {
//   data: {
//     id: string;
//     attributes: PictureAttributes;
//   };
// }

// interface ButtonProps {
//   id: number;
//   text: string;
//   url: string;
//   type: string;
//   isLive: boolean;
//   newTab: boolean;
// }

// interface ScrollProps {
//   id: string;
//   image: Picture;
//   image1?: Picture;
//   subtitle?: string | null;
//   title?: string | null;
// }

// interface ImageCarouselProps {
//   data: {
//     id: string;
//     scroll: ScrollProps[];
//     isLive: boolean;
//     layout?: string | null;
//     contentBoxAlignment?: string | null;
//     description?: string | null;
//     title?: string | null;
//     titleStyle?: string | null;
//     button?: ButtonProps;
//     textAligment?: string | null; // Added this property
//   };
// }

// const titleFonts = {
//   elegant: playfair.className,
//   modern: montserrat.className,
//   classic: libre.className,
//   minimal: inter.className,
//   serif: cormorant.className,
// };

// const titleSizes = {
//   small: "text-2xl md:text-3xl",
//   medium: "text-3xl md:text-4xl",
//   large: "text-4xl md:text-5xl",
//   xlarge: "text-5xl md:text-6xl",
// };

// const titleStyles = {
//   default: "font-light text-gray-800",
//   bold: "font-bold text-gray-900",
//   gradient:
//     "bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent",
//   underline: "font-semibold text-gray-800 border-b-2 border-gray-300 pb-2",
//   fancy: "font-medium text-gray-800 tracking-wider",
//   minimal: "font-light text-gray-700 tracking-tight",
// };

// export default function ImageCarousel_Banners({ data }: ImageCarouselProps) {
//   console.log("ImageCarousel_Banners data:.......", data);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isTransitioning, setIsTransitioning] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);

//   const slides = data.scroll || [];

//   useEffect(() => {
//     // console.log("ImageCarousel_Banners data:", data);
//     const checkMobile = () => setIsMobile(window.innerWidth < 768);
//     checkMobile();
//     window.addEventListener("resize", checkMobile);
//     return () => window.removeEventListener("resize", checkMobile);
//   }, []);

//   useEffect(() => {
//     if (slides.length <= 1) return;
//     const interval = setInterval(() => goToNext(), 4000);
//     return () => clearInterval(interval);
//   }, [slides.length, currentIndex]);

//   if (!data.isLive || !slides?.length) return null;

//   const goToPrev = () => {
//     if (isTransitioning) return;
//     setIsTransitioning(true);
//     setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
//     setTimeout(() => setIsTransitioning(false), 500);
//   };

//   const goToNext = () => {
//     if (isTransitioning) return;
//     setIsTransitioning(true);
//     setCurrentIndex((prev) => (prev + 1) % slides.length);
//     setTimeout(() => setIsTransitioning(false), 500);
//   };

//   const goToSlide = (index: number) => {
//     if (isTransitioning) return;
//     setIsTransitioning(true);
//     setCurrentIndex(index);
//     setTimeout(() => setIsTransitioning(false), 500);
//   };

//   const getAlignment = (): "left" | "right" | "center" => {
//     // Use the textAligment from data, fallback to 'left'
//     const alignment = data.textAligment?.toLowerCase();

//     if (
//       alignment === "left" ||
//       alignment === "right" ||
//       alignment === "center"
//     ) {
//       return alignment;
//     }

//     // You could also check contentBoxAlignment as fallback
//     const contentAlignment = data.contentBoxAlignment?.toLowerCase();
//     if (
//       contentAlignment === "left" ||
//       contentAlignment === "right" ||
//       contentAlignment === "center"
//     ) {
//       return contentAlignment;
//     }

//     return "left"; // Default fallback
//   };

//   const getAlignmentClasses = (alignment: "left" | "right" | "center") => {
//     switch (alignment) {
//       case "left":
//         return {
//           container: "justify-start",
//           text: "text-left",
//           button: "justify-start",
//           padding: "pl-4 md:pl-6 lg:pl-8 xl:pl-12",
//         };
//       case "right":
//         return {
//           container: "justify-end",
//           text: "text-right",
//           button: "justify-end",
//           padding: "pr-4 md:pr-6 lg:pr-8 xl:pr-12",
//         };
//       case "center":
//         return {
//           container: "justify-center",
//           text: "text-center",
//           button: "justify-center",
//           padding: "px-4 md:px-6 lg:px-8",
//         };
//       default:
//         return {
//           container: "justify-start",
//           text: "text-left",
//           button: "justify-start",
//           padding: "pl-4 md:pl-6 lg:pl-8 xl:pl-12",
//         };
//     }
//   };

//   const getTitleStyle = () => {
//     const font = data.titleStyle?.split("-")[0] || "elegant";
//     const size = data.titleStyle?.split("-")[1] || "medium";
//     const style = data.titleStyle?.split("-")[2] || "default";

//     return `${
//       titleFonts[font as keyof typeof titleFonts] || playfair.className
//     } ${
//       titleSizes[size as keyof typeof titleSizes] || "text-3xl md:text-4xl"
//     } ${
//       titleStyles[style as keyof typeof titleStyles] ||
//       "font-light text-gray-800"
//     }`;
//   };

//   return (
//     <>
//       <section className="w-full mt-6">
//         {data.title && (
//           <div className="container mx-auto px-4 mb-1 md:mb-2">
//             <div className="relative ">
//               <h1
//                 className={`
//               ${getTitleStyle()}
//               text-center mb-4
//               transition-all duration-300
//               hover:transform hover:scale-[1.02]
//             `}
//               >
//                 {data.title}
//               </h1>

//               <div className="flex justify-center mb-6">
//                 <div className="w-24 h-1 bg-gradient-to-r from-gray-300 via-gray-400 to-gray-300 rounded-full"></div>
//               </div>

//               {data.description && (
//                 <p className="text-gray-600 text-center mt-4 max-w-2xl mx-auto text-lg leading-relaxed">
//                   {data.description}
//                 </p>
//               )}
//             </div>
//           </div>
//         )}

//         <div className="relative w-full h-[500px] overflow-hidden group">
//           {slides.map((item, index) => {

//             const isActive = index === currentIndex;

//             const imgAttrs =
//               isMobile && item.image1?.data?.attributes
//                 ? item.image1.data.attributes
//                 : item.image?.data?.attributes;

//             if (!imgAttrs) return null;

//             const alignment = getAlignment();
//             const alignmentClasses = getAlignmentClasses(alignment);

//             return (
//               <div
//                 key={item.id || `slide-${index}`}
//                 className={`absolute inset-0 transition-all duration-500 ease-out ${
//                   isActive
//                     ? "opacity-100 translate-x-0"
//                     : "opacity-0 translate-x-4"
//                 }`}
//               >
//                 <div className="relative w-full h-[500px] md:h-[600px]">
//                   <Image
//                     src={imgAttrs.url}
//                     alt={imgAttrs.alternativeText || "Banner"}
//                     fill
//                     priority={index === 0}
//                     sizes="100vw"
//                     className="object-cover object-center"
//                     quality={100}
//                   />
//                 </div>

//                 {(item.title || item.subtitle || data.button?.isLive) && (
//                   <div
//                     className={`absolute inset-0 flex items-center z-10 ${alignmentClasses.container} ${alignmentClasses.padding}`}
//                   >
//                     <div
//                       className={`max-w-md text-white ${
//                         alignmentClasses.text
//                       } ${alignment === "center" ? "mx-auto" : ""}`}
//                     >
//                       {item.subtitle && (
//                         <div
//                           className={`text-sm font-light tracking-widest mb-4 transition-all duration-500 uppercase ${
//                             isActive ? "opacity-100" : "opacity-0 translate-y-6"
//                           }`}
//                           style={{
//                             transitionDelay: "100ms",
//                             letterSpacing: "0.2em",
//                           }}
//                         >
//                           {item.subtitle}
//                         </div>
//                       )}

//                       {item.title && (
//                         <h2
//                           className={`${
//                             playfair.className
//                           } text-3xl md:text-5xl font-light mb-8 leading-tight transition-all duration-500 ${
//                             isActive ? "opacity-100" : "opacity-0 translate-y-6"
//                           }`}
//                           style={{ transitionDelay: "200ms" }}
//                         >
//                           {item.title}
//                         </h2>
//                       )}

//                       {data.button?.isLive && (
//                         <div className={`flex ${alignmentClasses.button}`}>
//                           <a
//                             href={data.button.url}
//                             target={data.button.newTab ? "_blank" : "_self"}
//                             className={`group inline-flex items-center px-6 py-2 font-medium tracking-wide transition-all duration-500 hover:gap-3 ${
//                               isActive
//                                 ? "opacity-100"
//                                 : "opacity-0 translate-y-6"
//                             } bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full border border-white/20 hover:border-white/40`}
//                             style={{ transitionDelay: "300ms" }}
//                           >
//                             <span>{data.button.text}</span>
//                             <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
//                           </a>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             );
//           })}

//           {slides.length > 1 && (
//             <>
//               <button
//                 onClick={goToPrev}
//                 className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/30 text-white p-2 md:p-3 rounded-full z-20 transition-all duration-300 opacity-0 group-hover:opacity-100 backdrop-blur-sm border border-white/20 hover:border-white/40 hover:scale-110"
//               >
//                 <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" />
//               </button>

//               <button
//                 onClick={goToNext}
//                 className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/30 text-white p-2 md:p-3 rounded-full z-20 transition-all duration-300 opacity-0 group-hover:opacity-100 backdrop-blur-sm border border-white/20 hover:border-white/40 hover:scale-110"
//               >
//                 <ChevronRight className="w-5 h-5 md:w-6 md:h-6" />
//               </button>
//             </>
//           )}

//           {slides.length > 1 && (
//             <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2 md:gap-3">
//               {slides.map((_, index) => (
//                 <button
//                   key={index}
//                   onClick={() => goToSlide(index)}
//                   className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-300 ${
//                     index === currentIndex
//                       ? "bg-white scale-125 shadow-lg"
//                       : "bg-white/50 hover:bg-white/80 hover:scale-110"
//                   }`}
//                 />
//               ))}
//             </div>
//           )}
//         </div>
//       </section>
//     </>
//   );
// }

"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";
import { ChevronLeft, ChevronRight, ArrowRight } from "lucide-react";
import {
  Cormorant_Garamond,
  Playfair_Display,
  Inter,
  Montserrat,
  Libre_Baskerville,
} from "next/font/google";
import HeroBanner from "../HeroBanner";
import Link from "next/link";

const cormorant = Cormorant_Garamond({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700"],
});

const playfair = Playfair_Display({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700", "800", "900"],
});

const inter = Inter({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700"],
});

const montserrat = Montserrat({
  subsets: ["latin"],
  weight: ["300", "400", "500", "600", "700", "800"],
});

const libre = Libre_Baskerville({
  subsets: ["latin"],
  weight: ["400", "700"],
});

interface PictureAttributes {
  url: string;
  alternativeText: string | null;
  caption?: string | null;
  width?: number;
  height?: number;
}

interface Picture {
  data: {
    id: string;
    attributes: PictureAttributes;
  };
}

interface ButtonProps {
  id: number;
  text: string;
  url: string;
  type: string;
  isLive: boolean;
  newTab: boolean;
}

interface ScrollProps {
  id: string;
  image: Picture;
  image1?: Picture;
  subtitle?: string | null;
  title?: string | null;
  mediaUrl?: string | null; // Added mediaUrl to allow redirection on click
}

interface ImageCarouselProps {
  data: {
    id: string;
    scroll: ScrollProps[];
    isLive: boolean;
    layout?: string | null;
    contentBoxAlignment?: string | null;
    description?: string | null;
    title?: string | null;
    titleStyle?: string | null;
    button?: ButtonProps;
    textAligment?: string | null;
  };
}

const titleFonts = {
  elegant: playfair.className,
  modern: montserrat.className,
  classic: libre.className,
  minimal: inter.className,
  serif: cormorant.className,
};

const titleSizes = {
  small: "text-2xl md:text-3xl",
  medium: "text-3xl md:text-4xl",
  large: "text-4xl md:text-5xl",
  xlarge: "text-5xl md:text-6xl",
};

const titleStyles = {
  default: "font-light text-gray-800",
  bold: "font-bold text-gray-900",
  gradient:
    "bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent",
  underline: "font-semibold text-gray-800 border-b-2 border-gray-300 pb-2",
  fancy: "font-medium text-gray-800 tracking-wider",
  minimal: "font-light text-gray-700 tracking-tight",
};

export default function ImageCarousel_Banners({ data }: ImageCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const slides = data.scroll || [];

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (slides.length <= 1) return;
    const interval = setInterval(() => goToNext(), 4000);
    return () => clearInterval(interval);
  }, [slides.length, currentIndex]);

  if (!data.isLive || !slides?.length) return null;

  const goToPrev = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const goToNext = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => (prev + 1) % slides.length);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const goToSlide = (index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex(index);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const getAlignment = (): "left" | "right" | "center" => {
    const alignment = data.textAligment?.toLowerCase();
    if (
      alignment === "left" ||
      alignment === "right" ||
      alignment === "center"
    ) {
      return alignment;
    }

    const contentAlignment = data.contentBoxAlignment?.toLowerCase();
    if (
      contentAlignment === "left" ||
      contentAlignment === "right" ||
      contentAlignment === "center"
    ) {
      return contentAlignment;
    }

    return "left";
  };

  const getAlignmentClasses = (alignment: "left" | "right" | "center") => {
    switch (alignment) {
      case "left":
        return {
          container: "justify-start",
          text: "text-left",
          button: "justify-start",
          padding: "pl-4",
        };
      case "right":
        return {
          container: "justify-end",
          text: "text-right",
          button: "justify-end",
          padding: "pr-4",
        };
      case "center":
        return {
          container: "justify-center",
          text: "text-center",
          button: "justify-center",
          padding: "px-4",
        };
      default:
        return {
          container: "justify-start",
          text: "text-left",
          button: "justify-start",
          padding: "pl-4",
        };
    }
  };

  const getTitleStyle = () => {
    const font = data.titleStyle?.split("-")[0] || "elegant";
    const size = data.titleStyle?.split("-")[1] || "medium";
    const style = data.titleStyle?.split("-")[2] || "default";
    return `${titleFonts[font as keyof typeof titleFonts]} ${
      titleSizes[size as keyof typeof titleSizes]
    } ${titleStyles[style as keyof typeof titleStyles]}`;
  };

  return (
    <section className="w-full mt-6">
      {data.title && (
        <div className="container mx-auto px-4 mb-1 md:mb-2">
          <h1
            className={`${getTitleStyle()} text-center mb-4 transition-all duration-300`}
          >
            {data.title}
          </h1>
          <div className="flex justify-center mb-6">
            <div className="w-24 h-1 bg-gradient-to-r from-gray-300 via-gray-400 to-gray-300 rounded-full"></div>
          </div>
        </div>
      )}

      <div className="relative w-full h-[500px] overflow-hidden group">
        {slides.map((item, index) => {
          const isActive = index === currentIndex;
          const imgAttrs =
            isMobile && item.image1?.data?.attributes
              ? item.image1.data.attributes
              : item.image?.data?.attributes;
          if (!imgAttrs) return null;

          const alignment = getAlignment();
          const alignmentClasses = getAlignmentClasses(alignment);
          const slideLink = item.mediaUrl || "#"; // If mediaUrl exists, use it

          return (
            <div
              key={item.id || `slide-${index}`}
              className={`absolute inset-0 transition-all duration-500 ease-out ${
                isActive
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 translate-x-4"
              }`}
            >
              <div className="relative w-full h-[500px] md:h-[600px]">
                <Link href={slideLink} className="w-full h-full block">
                  <Image
                    src={imgAttrs.url}
                    alt={imgAttrs.alternativeText || "Banner"}
                    fill
                    priority={index === 0}
                    sizes="100vw"
                    className="object-cover object-center"
                    quality={100}
                  />
                </Link>
              </div>

              {(item.title || item.subtitle || data.button?.isLive) && (
                <div
                  className={`absolute inset-0 flex items-center z-10 ${alignmentClasses.container} ${alignmentClasses.padding}`}
                >
                  <div
                    className={`max-w-md text-white ${alignmentClasses.text}`}
                  >
                    {item.subtitle && (
                      <div
                        className={`text-sm font-light tracking-widest mb-4 transition-all duration-500 uppercase ${
                          isActive ? "opacity-100" : "opacity-0 translate-y-6"
                        }`}
                        style={{ transitionDelay: "100ms" }}
                      >
                        {item.subtitle}
                      </div>
                    )}

                    {item.title && (
                      <h2
                        className={`text-3xl md:text-5xl font-light mb-8 leading-tight transition-all duration-500 ${
                          isActive ? "opacity-100" : "opacity-0 translate-y-6"
                        }`}
                      >
                        {item.title}
                      </h2>
                    )}

                    {data.button?.isLive && (
                      <div className={`flex ${alignmentClasses.button}`}>
                        <a
                          href={data.button.url}
                          target={data.button.newTab ? "_blank" : "_self"}
                          className="group inline-flex items-center px-6 py-2 font-medium tracking-wide transition-all duration-500 hover:gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full border border-white/20 hover:border-white/40"
                        >
                          <span>{data.button.text}</span>
                          <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-300" />
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })}

        {slides.length > 1 && (
          <>
            <button
              onClick={goToPrev}
              className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/30 text-white p-2 md:p-3 rounded-full z-20"
            >
              <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" />
            </button>
            <button
              onClick={goToNext}
              className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/30 text-white p-2 md:p-3 rounded-full z-20"
            >
              <ChevronRight className="w-5 h-5 md:w-6 md:h-6" />
            </button>
          </>
        )}

        {slides.length > 1 && (
          <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2 md:gap-3">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? "bg-white scale-125 shadow-lg"
                    : "bg-white/50 hover:bg-white/80 hover:scale-110"
                }`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
